import React, { useState } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';

export default function() {
  const [greenOn, setGreenOn] = useState(false);
  const [redOn, setRedOn] = useState(false);
  const [blueOn, setBlueOn] = useState(false);

  const [PL, setPL] = useState(false);
  const [PD, setPD] = useState(false);
  const [IL, setIL] = useState(false);
  const [RBC, setRBC] = useState(false);
  const [FCA, setFCA] = useState(false);
  const [HQT, setHQT] = useState(false);
  const [DDDM, setDDDM] = useState(false);

  return (
    <svg width="362" height="755" viewBox="0 0 362 755">
      <defs>
        <filter
          id="DDDMCircle"
          x="149.5"
          y="555.5"
          width="201"
          height="201"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="HQTCircle"
          x="5.5"
          y="466.5"
          width="200"
          height="200"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-2" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="FCACircle"
          x="149.5"
          y="375.5"
          width="201"
          height="200"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-3" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="RBCCircle"
          x="5.5"
          y="283.5"
          width="200"
          height="200"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-4" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="ILCircle"
          x="149.5"
          y="193.5"
          width="201"
          height="201"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-5" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="PDCircle"
          x="5.5"
          y="100.5"
          width="200"
          height="200"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-6" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-6" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="PLCircle"
          x="149.5"
          y="13.5"
          width="201"
          height="200"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-7" />
          <feFlood flood-color="#223646" flood-opacity="0.18" />
          <feComposite operator="in" in2="blur-7" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="clip-Framework">
          <rect width="362" height="755" />
        </clipPath>
      </defs>
      <g id="Framework" clip-path="url(#clip-Framework)">
        <rect width="362" height="755" fill="#fff" />
        <g id="GreenHover" style={{ display: greenOn ? 'block' : 'none' }}>
          <path
            id="GreenOutline"
            d="M529,5755.5a94.612,94.612,0,0,1,68.071-90.649A94.6,94.6,0,0,1,530,5574.5c0-45.529,32.368-83.539,75.464-92.5-43.1-8.96-75.464-46.97-75.464-92.5,0-52.19,42.533-94.5,95-94.5a94.926,94.926,0,0,1,49.2,13.643q-.2-3.047-.2-6.144c0-52.19,42.533-94.5,95-94.5s95,42.309,95,94.5a94.588,94.588,0,0,1-65.453,89.84,94.394,94.394,0,0,1-2.842,181.159,94.623,94.623,0,0,1,69.295,91c0,52.19-42.532,94.5-95,94.5a94.919,94.919,0,0,1-51.723-15.221A94.928,94.928,0,0,1,719,5755.5c0,52.191-42.534,94.5-95,94.5S529,5807.691,529,5755.5Z"
            transform="translate(-519 -5189)"
            fill="#2de858"
            opacity="0.106"
          />
        </g>
        <g id="BlueHover" style={{ display: blueOn ? 'block' : 'none' }}>
          <path
            id="BlueOutline"
            d="M529,5572.5a94.617,94.617,0,0,1,68.8-90.86A94.619,94.619,0,0,1,528,5390.5c0-52.191,42.533-94.5,95-94.5s95,42.309,95,94.5a94.826,94.826,0,0,1-.816,12.438A94.9,94.9,0,0,1,770,5387c52.467,0,95,42.309,95,94.5s-42.533,94.5-95,94.5a94.923,94.923,0,0,1-51.723-15.222A94.938,94.938,0,0,1,719,5572.5c0,52.191-42.533,94.5-95,94.5S529,5624.691,529,5572.5Z"
            transform="translate(-516 -5006)"
            fill="#28d2f9"
            opacity="0.11"
          />
          <text
            id="BlueOutlineText"
            transform="translate(105 687)"
            fill="#009de0"
            font-size="14"
            font-family="SourceSansPro-Semibold, Source Sans Pro"
            font-weight="600"
          >
            <tspan x="-37.842" y="0">
              CLASSROOM
            </tspan>
            <tspan x="-29.61" y="18">
              PRACTICE
            </tspan>
          </text>
        </g>
        <g id="RedHover" style={{ display: redOn ? 'block' : 'none' }}>
          <path
            id="RedOutline"
            d="M675,5482.5a94.866,94.866,0,0,1,.921-13.209A94.934,94.934,0,0,1,625,5484c-52.467,0-95-42.308-95-94.5s42.532-94.5,95-94.5,95,42.309,95,94.5a94.833,94.833,0,0,1-.92,13.207A94.928,94.928,0,0,1,770,5388c52.467,0,95,42.31,95,94.5s-42.534,94.5-95,94.5S675,5534.69,675,5482.5Z"
            transform="translate(-519 -5188)"
            fill="#d8014d"
            opacity="0.1"
          />
          <text
            id="RedOutlineText"
            transform="translate(105 72)"
            fill="#d8004d"
            font-size="14"
            font-family="SourceSansPro-Semibold, Source Sans Pro"
            font-weight="600"
          >
            <tspan x="-38.843" y="0">
              WORKFORCE
            </tspan>
            <tspan x="-45.213" y="18">
              DEVELOPMENT
            </tspan>
          </text>
        </g>
        <path
          id="Arrows"
          d="M59.63,902.375A85.649,85.649,0,0,1-10,818h1.432A84.214,84.214,0,0,0,59.807,900.95l.8-6.439L72,903.118l-13.151,5.567ZM238,813.118l11.4-8.606.8,6.439A84.214,84.214,0,0,0,318.568,728H320a85.649,85.649,0,0,1-69.63,84.376l.781,6.31ZM59.63,720.374A85.648,85.648,0,0,1-10,636h1.432a84.215,84.215,0,0,0,68.376,82.951l.8-6.439L72,721.118l-13.151,5.567ZM238,632.118l11.4-8.606.8,6.439A84.213,84.213,0,0,0,318.568,547H320a85.648,85.648,0,0,1-69.63,84.375l.781,6.311ZM60.63,537.375A85.648,85.648,0,0,1-9,453h1.432a84.214,84.214,0,0,0,68.376,82.95l.8-6.438L73,538.118l-13.151,5.567Z"
          transform="translate(22.001 -245.423)"
          fill="#666"
          stroke="rgba(0,0,0,0)"
          stroke-miterlimit="10"
          stroke-width="1"
          opacity="0.386"
        />
        <Link
          activeClass="active"
          to="DDDMBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="DDDM"
            onMouseOver={() => {
              setDDDM(true);
            }}
            onMouseOut={() => {
              setDDDM(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#DDDMCircle)">
              <circle
                id="DDDMCircle-2"
                data-name="DDDMCircle"
                cx="78"
                cy="78"
                r="78"
                transform="translate(172 577)"
                fill={DDDM ? '#223646' : '#fff'}
              />
            </g>
            <text
              id="DDDMText"
              transform="translate(250 667)"
              fill={DDDM ? '#FFFFFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-41.064" y="0">
                Data-Driven
              </tspan>
              <tspan x="-29.312" y="19">
                Decision
              </tspan>
              <tspan x="-25.048" y="38">
                Making
              </tspan>
            </text>
            <g id="DDDMIcon" transform="translate(1132 530.5)">
              <path
                id="Union_2"
                data-name="Union 2"
                d="M-1105-20V-47h7v27Zm-9,0V-40h7v20Zm-9,0V-31h7v11Zm-9,0V-37h7v17Zm9.5-17.5a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-1122.5-37.5Zm-9-7a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-1131.5-44.5Zm18-3a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-1113.5-47.5Zm9-9a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-1104.5-56.5Z"
                transform="translate(233 129)"
                fill={DDDM ? '#FFFFFF' : '#223646'}
                stroke="rgba(0,0,0,0)"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <path
                id="Path_47672"
                data-name="Path 47672"
                d="M-895.5,84.5l8.844,7.541,9.228-10.754,8.7-8.7"
                fill="none"
                stroke={DDDM ? '#FFFFFF' : '#223646'}
                stroke-miterlimit="10"
                stroke-width="1.632"
              />
            </g>
          </g>
        </Link>
        <Link
          activeClass="active"
          to="HQTBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="HQT"
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
            onMouseOver={() => {
              setBlueOn(true);
              setHQT(true);
            }}
            onMouseOut={() => {
              setBlueOn(false);
              setHQT(false);
            }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#HQTCircle)">
              <circle
                id="HQTCircle-2"
                data-name="HQTCircle"
                cx="77.5"
                cy="77.5"
                r="77.5"
                transform="translate(28 488)"
                fill={HQT ? '#24bcf4' : '#fff'}
              />
            </g>
            <text
              id="HQTText"
              transform="translate(106 588)"
              fill={HQT ? '#FFFFFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-43.792" y="0">
                High-Quality
              </tspan>
              <tspan x="-30.824" y="19">
                Teaching
              </tspan>
            </text>
            <path
              id="HQTIcon"
              d="M-1013.685-63.356l-1.171-6.422h-15.619l-1.17,6.422h-3.211l1.17-6.422h-1.907V-72.99h2.492l.473-2.594h3.211l-.472,2.594h14.449l-.473-2.594h3.211l.473,2.594h2.822v3.211h-2.237l1.171,6.422ZM-1042-77.461v-5.571h2.229v-23.4h34.542v23.4H-1003v5.571Zm8.915-11.142h14.485v-3.343h-14.485Zm0-7.8h18.942v-3.343h-18.942Zm8.914-12.257v-3.9a1.671,1.671,0,0,1,1.671-1.671,1.671,1.671,0,0,1,1.671,1.671v3.9Z"
              transform="translate(1128 622.856)"
              fill={HQT ? '#FFF' : '#24bcf4'}
              stroke="rgba(0,0,0,0)"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </Link>
        <Link
          activeClass="active"
          to="FCABlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="FCA"
            onMouseOver={() => {
              setBlueOn(true);
              setFCA(true);
            }}
            onMouseOut={() => {
              setBlueOn(false);
              setFCA(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#FCACircle)">
              <ellipse
                id="FCACircle-2"
                data-name="FCACircle"
                cx="78"
                cy="77.5"
                rx="78"
                ry="77.5"
                transform="translate(172 397)"
                fill={FCA ? '#24bcf4' : '#fff'}
              />
            </g>
            <text
              id="FCAText"
              transform="translate(250 496)"
              fill={FCA ? '#FFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-54.616" y="0">
                Formative Child
              </tspan>
              <tspan x="-40.728" y="19">
                Assessment
              </tspan>
            </text>
            <path
              id="FCAIcon"
              d="M-1411.362,166.855V130.15h5.2v3.668h21.034V130.15h5.04v36.706Zm5.671-14.08a.96.96,0,0,0,0,1.39l1.787,1.786a.957.957,0,0,0,1.389,0l3.673-3.572a.961.961,0,0,0,0-1.39,1.079,1.079,0,0,0-1.489,0l-2.878,2.879-1.092-1.092a.98.98,0,0,0-.7-.3A.981.981,0,0,0-1405.691,152.775Zm9.176,2.291h11.556V152.49h-11.556Zm-9.176-12.291a.96.96,0,0,0,0,1.39l1.787,1.786a.957.957,0,0,0,1.389,0l3.673-3.573a.96.96,0,0,0,0-1.39,1.079,1.079,0,0,0-1.489,0l-2.878,2.879-1.092-1.092a.979.979,0,0,0-.7-.3A.98.98,0,0,0-1405.691,142.775Zm9.176,2.291h11.556V142.49h-11.556Zm-8.057-13.112v-4.017h3.514a1.258,1.258,0,0,0,1.256-1.255V125.3a4.155,4.155,0,0,1,4.966-3.933,4.13,4.13,0,0,1,3.191,4.092v1.222a1.258,1.258,0,0,0,1.255,1.255h3.514v4.017Z"
              transform="translate(1647.086 300.644)"
              fill={FCA ? '#FFFFFF' : '#24bcf4'}
              stroke="rgba(0,0,0,0)"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </Link>
        <Link
          activeClass="active"
          to="RBCBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="RBC"
            onMouseOver={() => {
              setBlueOn(true);
              setRBC(true);
            }}
            onMouseOut={() => {
              setBlueOn(false);
              setRBC(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#RBCCircle)">
              <circle
                id="RBCCircle-2"
                data-name="RBCCircle"
                cx="77.5"
                cy="77.5"
                r="77.5"
                transform="translate(28 305)"
                fill={RBC ? '#24bcf4' : '#fff'}
              />
            </g>
            <text
              id="RBCText"
              transform="translate(106 403)"
              fill={RBC ? '#FFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-54.92" y="0">
                Research-Based
              </tspan>
              <tspan x="-38.68" y="19">
                Curriculum
              </tspan>
            </text>
            <path
              id="RBCIcon"
              d="M-1026.4,245.537V239h43.678v6.542Zm30.374-9.205a8.535,8.535,0,0,0-8.536-8.535,8.534,8.534,0,0,0-8.535,8.535h-8.892v-14.7h34.854v14.7Zm-15.962-16.846V204.632h14.854v14.854Z"
              transform="translate(1110.06 128.368)"
              fill={RBC ? '#FFF' : '#24bcf4'}
              stroke="rgba(0,0,0,0)"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </Link>
        <Link
          activeClass="active"
          to="ILBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="IL"
            onMouseOver={() => {
              setRedOn(true);
              setIL(true);
            }}
            onMouseOut={() => {
              setRedOn(false);
              setIL(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ILCircle)">
              <path
                id="ILCircle-2"
                data-name="ILCircle"
                d="M78,0A78,78,0,1,1,0,78,78,78,0,0,1,78,0Z"
                transform="translate(172 215)"
                fill={IL ? '#d8004d' : '#fff'}
              />
            </g>
            <text
              id="ILText"
              transform="translate(250 317)"
              fill={IL ? '#FFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-44.24" y="0">
                Instructional
              </tspan>
              <tspan x="-38.112" y="19">
                Leadership
              </tspan>
            </text>
            <path
              id="ILIcon"
              d="M-1043.681,281.363l-2.276-2.275a.847.847,0,0,1,0-1.225.847.847,0,0,1,1.226,0l.787.788v-7.438a.826.826,0,0,1,.875-.875.826.826,0,0,1,.875.875v7.438l.787-.788a.844.844,0,0,1,1.225,0,.846.846,0,0,1,0,1.225l-2.274,2.275a.867.867,0,0,1-.613.262A.863.863,0,0,1-1043.681,281.363Zm16.625-7.7a.826.826,0,0,1-.875-.875.825.825,0,0,1,.875-.875h1.049l-5.25-5.251a.846.846,0,0,1,0-1.225.845.845,0,0,1,1.225,0l5.25,5.25v-1.049a.826.826,0,0,1,.876-.875.826.826,0,0,1,.875.875v3.15a.827.827,0,0,1-.875.875Zm-35.176,0a.827.827,0,0,1-.875-.875v-3.15a.826.826,0,0,1,.875-.875.826.826,0,0,1,.875.875v1.049l5.251-5.25a.846.846,0,0,1,1.225,0,.846.846,0,0,1,0,1.225l-5.25,5.251h1.048a.827.827,0,0,1,.877.875.827.827,0,0,1-.877.875Zm10.849-8.75v-1.75a8.443,8.443,0,0,1,8.313-6.737,8.346,8.346,0,0,1,8.224,6.737v1.75a14.032,14.032,0,0,1-8.224,2.713A14.307,14.307,0,0,1-1051.382,264.912Zm18.2-1.837V262.9a10.135,10.135,0,0,0-9.976-8.312,10.134,10.134,0,0,0-9.975,8.312v.176h.087v.349a13.677,13.677,0,0,1-4.025-9.8,14.041,14.041,0,0,1,14-14,14.041,14.041,0,0,1,14,14,13.4,13.4,0,0,1-4.112,9.8Zm-14.7-14.263a4.856,4.856,0,0,0,4.812,4.813,4.856,4.856,0,0,0,4.813-4.813,4.856,4.856,0,0,0-4.813-4.812A4.856,4.856,0,0,0-1047.882,248.812Zm29.051,7.7a.846.846,0,0,1,0-1.225l.787-.787h-7.438a.826.826,0,0,1-.874-.875.826.826,0,0,1,.874-.875h7.438l-.787-.788a.846.846,0,0,1,0-1.225.846.846,0,0,1,1.225,0l2.274,2.275a.791.791,0,0,1,.263.612.794.794,0,0,1-.263.613l-2.274,2.274a.864.864,0,0,1-.613.263A.86.86,0,0,1-1018.831,256.512Zm-49.7,0-2.274-2.274a.846.846,0,0,1,0-1.225l2.274-2.275a.847.847,0,0,1,1.226,0,.849.849,0,0,1,0,1.225l-.788.788h7.438a.827.827,0,0,1,.876.875.827.827,0,0,1-.876.875h-7.437l.788.787a.849.849,0,0,1,0,1.225.864.864,0,0,1-.613.263A.861.861,0,0,1-1068.531,256.512Zm22.4-7.7a3.1,3.1,0,0,1,3.063-3.062,3.1,3.1,0,0,1,3.062,3.062,3.1,3.1,0,0,1-3.062,3.063A3.1,3.1,0,0,1-1046.131,248.812Zm14.875-7a.846.846,0,0,1,0-1.225l5.25-5.25h-1.049a.826.826,0,0,1-.875-.876.826.826,0,0,1,.875-.875h3.15a.827.827,0,0,1,.875.875v3.15a.827.827,0,0,1-.875.876.827.827,0,0,1-.876-.876v-1.049l-5.25,5.25a.864.864,0,0,1-.613.263A.86.86,0,0,1-1031.256,241.812Zm-24.85,0-5.251-5.25v1.049a.827.827,0,0,1-.875.876.827.827,0,0,1-.875-.876v-3.15a.827.827,0,0,1,.875-.875h3.149a.827.827,0,0,1,.877.875.827.827,0,0,1-.877.876h-1.048l5.25,5.25a.846.846,0,0,1,0,1.225.864.864,0,0,1-.613.263A.861.861,0,0,1-1056.106,241.812Zm12.163-5.775V228.6l-.787.788a.848.848,0,0,1-1.226,0,.848.848,0,0,1,0-1.226l2.276-2.274a.846.846,0,0,1,1.225,0l2.274,2.274a.847.847,0,0,1,0,1.226.847.847,0,0,1-1.225,0l-.787-.788v7.437a.827.827,0,0,1-.875.876A.827.827,0,0,1-1043.943,236.037Z"
              transform="translate(1293.094 10.4)"
              fill={IL ? '#FFFFFF' : '#d8004d'}
              stroke="rgba(0,0,0,0)"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </Link>
        <Link
          activeClass="active"
          to="PDBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="PD"
            onMouseOver={() => {
              setRedOn(true);
              setPD(true);
            }}
            onMouseOut={() => {
              setRedOn(false);
              setPD(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#PDCircle)">
              <circle
                id="PDCircle-2"
                data-name="PDCircle"
                cx="77.5"
                cy="77.5"
                r="77.5"
                transform="translate(28 122)"
                fill={PD ? '#d8004d' : '#fff'}
              />
            </g>
            <text
              id="PDText"
              transform="translate(106 220)"
              fill={PD ? '#FFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-42.688" y="0">
                Professional
              </tspan>
              <tspan x="-46.376" y="19">
                Development
              </tspan>
            </text>
            <g id="PDIcon" transform="translate(1137.739 222.167)">
              <path
                id="Path_47690"
                data-name="Path 47690"
                d="M-1012.208-38.042V-41h-38.459a5.917,5.917,0,0,0-5.916,5.917,5.916,5.916,0,0,0,5.916,5.916h38.459v-2.958h-2.959v-5.917Z"
                fill={PD ? '#FFFFFF' : '#d8004d'}
              />
              <path
                id="Path_47685"
                data-name="Path 47685"
                d="M-1023.6-62.911c-3.2-4.547-7.112-3.544-9.7-2.88-.274.07-.541.138-.794.2a8.661,8.661,0,0,1,4.539-6.611l-1.079-1.78a12.482,12.482,0,0,0-3.489,3.046,6.336,6.336,0,0,0-1.549-2.635c-1.353-1.353-3.366-2.021-5.983-1.984l-1.012.014-.014,1.012c-.037,2.618.63,4.631,1.983,5.984a7.266,7.266,0,0,0,4.654,1.935c-.064.341-.113.691-.146,1.047-.289-.064-.6-.143-.917-.225-2.591-.664-6.506-1.667-9.7,2.88-1.528,2.173-1.989,5.114-1.335,8.505.772,4,3.1,8.158,5.4,9.659,2.813,1.831,10.289,1.112,11.536,1.112a6.363,6.363,0,0,0,3.539-1.112c2.308-1.5,4.631-5.654,5.4-9.659C-1021.614-57.8-1022.076-60.738-1023.6-62.911Z"
                fill={PD ? '#FFFFFF' : '#d8004d'}
              />
              <path
                id="Path_47686"
                data-name="Path 47686"
                d="M-1040.864-44.03l11.139-11.139,6.663,6.663L-1012.97-58.6"
                fill="none"
                stroke="#fff"
                fill={PD ? '#d8004d' : '#FFFFFF'}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="7"
              />
              <path
                id="Path_47688"
                data-name="Path 47688"
                d="M-1010.476-54.041l2.58-9.632-9.632,2.58Z"
                fill={PD ? '#FFFFFF' : '#d8004d'}
              />
              <path
                id="Path_47687"
                data-name="Path 47687"
                d="M-1040.864-44.03l11.139-11.139,6.663,6.663L-1012.97-58.6"
                fill="none"
                stroke="#d8004d"
                stroke-miterlimit="10"
                stroke-width="2"
              />
              <rect
                id="Rectangle_6052"
                data-name="Rectangle 6052"
                width="24.667"
                height="2.667"
                transform="translate(-1045.729 -36.417)"
                fill={PD ? '#d8004d' : '#FFFFFF'}
              />
              <rect
                id="Rectangle_6053"
                data-name="Rectangle 6053"
                width="24.667"
                height="2.667"
                transform="translate(-1046.729 -36.417)"
                fill={PD ? '#d8004d' : '#FFFFFF'}
              />
            </g>
          </g>
        </Link>
        <Link
          activeClass="active"
          to="PLBlock"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <g
            id="PL"
            onMouseOver={() => {
              setGreenOn(true);
              setPL(true);
            }}
            onMouseOut={() => {
              setGreenOn(false);
              setPL(false);
            }}
            pointer-events="visiblePainted"
            style={{ cursor: 'pointer' }}
          >
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#PLCircle)">
              <ellipse
                id="PLCircle-2"
                data-name="PLCircle"
                cx="78"
                cy="77.5"
                rx="78"
                ry="77.5"
                transform="translate(172 35)"
                fill={PL ? '#30d076' : '#fff'}
              />
            </g>
            <text
              id="PLText"
              transform="translate(250 134)"
              fill={PL ? '#FFFFFF' : '#223646'}
              font-size="16"
              font-family="SourceSansPro-Semibold, Source Sans Pro"
              font-weight="600"
            >
              <tspan x="-28.088" y="0">
                Political
              </tspan>
              <tspan x="-38.112" y="19">
                Leadership
              </tspan>
            </text>
            <path
              id="PLIcon"
              d="M-954,343v-5h-4V325h10v18Zm-33,0v-4h4V323h-4v-4.086l16.5-3.976,16.5,3.976V323h-5v16h4v4Zm21-4h4V323h-4Zm-7,0h4V323h-4Zm-7,0h4V323h-4Zm-14,4V325h10v13h-4v5Zm23-35.61V300h6v5h-5v2.425a11.71,11.71,0,0,1,10.37,8.59l-10.518-2.534-.351-.085-.351.085-11.411,2.749A11.7,11.7,0,0,1-971,307.39Z"
              transform="translate(1221 -241)"
              fill={PL ? '#FFFFFF' : '#30d076'}
              stroke="rgba(0,0,0,0)"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </Link>
      </g>
    </svg>
  );
}
